namespace Matrix.Data {
    export interface DataVisualsForm {
        VisualName: Serenity.StringEditor;
        VisualKey: Serenity.StringEditor;
        Category: Serenity.StringEditor;
        Permission: Serenity.StringEditor;
        Url: Serenity.StringEditor;
        IsActive: Serenity.BooleanEditor;
    }

    export class DataVisualsForm extends Serenity.PrefixedContext {
        static formKey = 'Data.DataVisuals';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!DataVisualsForm.init)  {
                DataVisualsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.BooleanEditor;

                Q.initFormType(DataVisualsForm, [
                    'VisualName', w0,
                    'VisualKey', w0,
                    'Category', w0,
                    'Permission', w0,
                    'Url', w0,
                    'IsActive', w1
                ]);
            }
        }
    }
}
